import styled from "styled-components";

export const Container = styled.div`
   width: 100%;
   background-color: white;
   box-shadow: #fbe77724 0px 0px 20px;
   display: flex;
   align-items: center;
   border-radius: 10px;
   justify-content: space-between;
   height: 150px;
   padding-left:20px;
   .pontos{
      height: 100%;
      vertical-align: middle;
      width: 150px;
      background-color: #19a91b;
      margin-right: -2px;
      text-align: center;
      color: white;
      display: flex;
      justify-content: center;
      font-weight: bold;
      align-items: center;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      display: flex;
      flex-direction: column;
   }
   .pontos.pendente {
    background-color:rgb(230, 209, 91);
    color: #000;
   }
   .pontos.aprovado {
      background-color: #19a91b; 
   }
   .pontos.reprovado {
      background-color: #B91C1C;
   }
   .divide{
      height: -webkit-fill-available;
      width: 1px;
      background-color: #d2d0c1;
      margin-top: 15px;
      margin-bottom: 15px;
   }

   @media only screen and (max-width: 1080px) {
      flex-direction: column;
      height: auto;
      padding: 0px;
      .vendaSingle{
         padding: 30px 0px;
      }
      
      .pontos{
         padding: 10px;
         width: 100%;
         margin-right: 0px;
         border-radius: 0px;
         border-bottom-right-radius: 10px;
         border-bottom-left-radius: 10px;
      }

      .divide{
         margin-bottom: 15px;
         width: 100%;
         height: 2px;
      }
   }
`;

